import {
	type ChangelogVersion,
	RELEASE_STATUS_META,
} from "~/data/changelog-schema";
import { cn } from "~/utils/cn";

/**
 * Version heading shown above the timeline: number, status pill, and the
 * curated title/summary. In the editor (`showEmptyHints`) empty title/summary
 * render as muted placeholders so they are visible and clearly editable; the
 * public viewer omits them.
 */
export const VersionHeader = ({
	version,
	showEmptyHints = false,
}: {
	version: ChangelogVersion;
	showEmptyHints?: boolean;
}) => {
	const status = RELEASE_STATUS_META[version.status];
	const titleText = version.title || (showEmptyHints ? "No title set" : "");
	const summaryText =
		version.summary || (showEmptyHints ? "No summary set" : "");

	return (
		<header className="mb-5">
			<div className="flex items-center gap-2">
				<h2 className="font-bold text-foreground text-xl tracking-tight">
					Version {version.version}
				</h2>
				<span
					className={cn(
						"rounded-full px-2 py-0.5 font-semibold text-[11px]",
						status.className
					)}
				>
					{status.label}
				</span>
			</div>
			{titleText && (
				<p
					className={cn(
						"mt-1 font-medium text-[15px]",
						version.title
							? "text-foreground/90"
							: "text-muted-foreground/50 italic"
					)}
				>
					{titleText}
				</p>
			)}
			{summaryText && (
				<p
					className={cn(
						"mt-1 max-w-prose text-[13px] leading-relaxed",
						version.summary
							? "text-muted-foreground"
							: "text-muted-foreground/50 italic"
					)}
				>
					{summaryText}
				</p>
			)}
		</header>
	);
};
